<template>
  <div id="app">
    <Wrapper/>
  </div>
</template>

<script>
import Wrapper from './components/shared/Wrapper'

export default {
  name: 'App',
  components: {
    Wrapper
  }
}
</script>

<style lang="scss">
@import './scss/main.scss';

.main-panel {
  overflow-y: auto !important;
}

#app {
  overflow: auto !important;
}

@media (min-height: 600px) and (orientation: landscape) {
  #app {
    overflow: hidden !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/App.vue